import { DataCollectionCategories, Item } from 'modules/processes/domain'
import { TaskConfigurationTypes } from './taskConfigurationTypes'

const dataCollectionGeneralInformation = [
  DataCollectionCategories.generalInformation,
  DataCollectionCategories.address,
  DataCollectionCategories.emergency_contact,
  DataCollectionCategories.fiscal_residence,
  DataCollectionCategories.personalSituation,
]
export const itemTaskType = (item: Item): string | undefined => {
  const taskType = item.taskType
  const taskConfiguration = item.taskTypeConfiguration ? JSON.parse(item.taskTypeConfiguration) : {}

  if (taskType === TaskConfigurationTypes.DataCollection) {
    const category = taskConfiguration.configuration_fields[0].categories[0].category

    if (dataCollectionGeneralInformation.includes(category)) {
      return DataCollectionCategories.generalInformation
    }

    switch (category) {
      case DataCollectionCategories.identificationNumber:
        return DataCollectionCategories.identificationNumber
      case DataCollectionCategories.bankInformation:
        return DataCollectionCategories.bankInformation
      case DataCollectionCategories.employee_questions_cf:
        return DataCollectionCategories.employee_questions_cf
      case DataCollectionCategories.start_date:
      case DataCollectionCategories.role:
      case DataCollectionCategories.salary:
      case DataCollectionCategories.contract_hours:
      case DataCollectionCategories.contract_custom_fields:
        return DataCollectionCategories.contract_data
      default:
        return TaskConfigurationTypes.DataCollection
    }
  }

  return item.taskType || undefined
}
